<template>
  <div class="">
    <div class="breadcrumb">
      <v-breadcrumb>
        <!-- <v-breadcrumb-item>
          <v-icon type="home"></v-icon>
          <a @click="() => $router.push('/student/dashboard')">Dashboard </a>
        </v-breadcrumb-item> -->
        <v-breadcrumb-item>
          <span>Applications</span>
        </v-breadcrumb-item>
      </v-breadcrumb>
    </div>

    <v-button type="primary" size="small" @click="downloadData">Download</v-button>

    <v-tabs :active-tab-key="activeTab" style="margin-top: 8px;width:calc(100vw - 230px);" @change="onChange">

      <v-tab-pane tab-key="Applied" tab="New Applications" style="width:100%;">
        <div style="height:430px;overflow:auto;width:100%;">
          <div class="table" v-if="filteredApplications['Applied']">
            <div class="trow">
              <div class="thead student-id" @click="() => sortApplications('user_seq')">Student ID</div>
              <div class="thead app-id" @click="() => sortApplications('seq_id')">Application ID</div>
              <div class="thead app-date" @click="() => sortApplications('display_date')">Applied Date</div>
              <div class="thead school-name" @click="() => sortApplications('display_school')">School Name</div>
              <div class="thead program-name" @click="() => sortApplications('name')">Program Name</div>
              <div class="thead intake" @click="() => sortApplications('selected_intake')">Intake</div>
              <div class="thead actions">Actions</div>
            </div>
            <div class="trow">
              <div class="tdata student-id">
                <input type="text" placeholder="Search Student ID" v-model="searchStudentID" @keyup="(ev) => searchApplications('searchStudentID', ev.target.value)" />
              </div>
              <div class="tdata app-id">
                <input type="text" placeholder="Search Application ID" v-model="searchID" @keyup="(ev) => searchApplications('searchID', ev.target.value)" />
              </div>
              <div class="tdata app-date">
                <input type="text" placeholder="Search Application Date" v-model="searchDate" @keyup="(ev) => searchApplications('searchDate', ev.target.value)" />
              </div>
              <div class="tdata school-name">
                <input type="text" placeholder="Search School name" v-model="searchSchool" @keyup="(ev) => searchApplications('searchSchool', ev.target.value)" />
              </div>
              <div class="tdata program-name">
                <input type="text" placeholder="Search Program name" v-model="searchProgram" @keyup="(ev) => searchApplications('searchProgram', ev.target.value)" />
              </div>
              <div class="tdata intake">
                <input type="text" placeholder="Search Intake" v-model="searchIntake" @keyup="(ev) => searchApplications('searchIntake', ev.target.value)" />
              </div>
              <div class="tdata actions"></div>
            </div>
            <div v-for="application in filteredApplications['Applied']" :key="application.id">
              <div class="trow">
                <div class="tdata student-id">{{application.user_seq}}</div>
                <div class="tdata app-id">{{application.seq_id}}</div>
                <div class="tdata app-date">{{application.display_date}}</div>
                <div class="tdata school-name">{{application.display_school}}</div>
                <div class="tdata program-name">{{application.name}}</div>
                <div class="tdata intake">{{application.selected_intake}}</div>
                <div class="tdata actions">
                  <v-button type="primary" size="small" @click="() => assignApplication(application)">Assign Me</v-button>
                  <div>
                    <v-button type="primary" size="small" v-if="!applicationDetails.includes(application.id)" @click="() => showApplicationDetails(application)">Show Details</v-button>
                    <v-button type="primary" size="small" v-if="applicationDetails.includes(application.id)" @click="() => hideApplicationDetails(application)">Hide Details</v-button>
                  </div>
                </div>
              </div>
              <div class="details" v-if="applicationDetails.includes(application.id)">
                <ApplicationDetails :application="application" :fetchedUsers="fetchedUsers" :fetchedUserDetails="fetchedUserDetails" />
              </div>
            </div>
          </div>
        </div>
      </v-tab-pane>

      <v-tab-pane tab-key="Assigned" tab="In Process" style="width:100%;">
        <div style="overflow:auto;width:100%;">
          <div class="table" v-if="filteredApplications['Assigned']">
            <div class="trow">
              <div class="thead a-student-id" @click="() => sortApplications('user_seq')">Student ID</div>
              <div class="thead a-app-id" @click="() => sortApplications('seq_id')">Application ID</div>
              <div class="thead a-app-date" @click="() => sortApplications('display_date')">Applied Date</div>
              <div class="thead a-employee-name" @click="() => sortApplications('employee_name')">Employee Name</div>
              <div class="thead a-school-name" @click="() => sortApplications('display_school')">School Name</div>
              <div class="thead a-program-name" @click="() => sortApplications('name')">Program Name</div>
              <div class="thead a-intake" @click="() => sortApplications('selected_intake')">Intake</div>
              <div class="thead a-actions">Actions</div>
            </div>
            <div class="trow">
              <div class="tdata a-student-id">
                <input type="text" placeholder="Search Student ID" v-model="searchStudentID" @keyup="(ev) => searchApplications('searchStudentID', ev.target.value)" />
              </div>
              <div class="tdata a-app-id">
                <input type="text" placeholder="Search Application ID" v-model="searchID" @keyup="(ev) => searchApplications('searchID', ev.target.value)" />
              </div>
              <div class="tdata a-app-date">
                <input type="text" placeholder="Search Application date" v-model="searchDate" @keyup="(ev) => searchApplications('searchDate', ev.target.value)" />
              </div>
              <div class="tdata a-employee-name">
                <input type="text" placeholder="Search Employee" v-model="searchEmployee" @keyup="(ev) => searchApplications('searchEmployee', ev.target.value)" />
              </div>
              <div class="tdata a-school-name">
                <input type="text" placeholder="Search School name" v-model="searchSchool" @keyup="(ev) => searchApplications('searchSchool', ev.target.value)" />
              </div>
              <div class="tdata a-program-name">
                <input type="text" placeholder="Search Program name" v-model="searchProgram" @keyup="(ev) => searchApplications('searchProgram', ev.target.value)" />
              </div>
              <div class="tdata a-intake">
                <input type="text" placeholder="Search Intake" v-model="searchIntake" @keyup="(ev) => searchApplications('searchIntake', ev.target.value)" />
              </div>
              <div class="tdata a-actions"></div>
            </div>
            <div v-for="application in filteredApplications['Assigned']" :key="application.id">
              <div class="trow">
                <div class="tdata a-student-id">{{application.user_seq}}</div>
                <div class="tdata a-app-id">{{application.seq_id}}</div>
                <div class="tdata a-app-date">{{application.display_date}}</div>
                <div class="tdata a-employee-name">{{application.employee_name}}</div>
                <div class="tdata a-school-name">{{application.display_school}}</div>
                <div class="tdata a-program-name">{{application.name}}</div>
                <div class="tdata a-intake">{{application.selected_intake}}</div>
                <div class="tdata a-actions">
                  <v-button type="primary" size="small" @click="() => submittedApplication(application)">Submit Application</v-button>
                  <div>
                    <v-button type="primary" size="small" v-if="!applicationDetails.includes(application.id)" @click="() => showApplicationDetails(application)">Show Details</v-button>
                    <v-button type="primary" size="small" v-if="applicationDetails.includes(application.id)" @click="() => hideApplicationDetails(application)">Hide Details</v-button>
                  </div>
                </div>
              </div>
              <div class="details" v-if="applicationDetails.includes(application.id)">
                <ApplicationDetails :application="application" :fetchedUsers="fetchedUsers" :fetchedUserDetails="fetchedUserDetails" />
              </div>
            </div>
          </div>
        </div>
      </v-tab-pane>

      <v-tab-pane tab-key="Submitted" tab="Submitted Application" style="width:100%;">
        <div style="overflow:auto;width:100%;">
          <div class="table" v-if="filteredApplications['Submitted']">
            <div class="trow">
              <div class="thead s-student-id" @click="() => sortApplications('user_seq')">Student ID</div>
              <div class="thead s-app-id" @click="() => sortApplications('seq_id')">Application ID</div>
              <div class="thead s-app-date" @click="() => sortApplications('display_date')">Applied Date</div>
              <div class="thead s-employee-name" @click="() => sortApplications('employee_name')">Employee Name</div>
              <div class="thead s-school-name" @click="() => sortApplications('display_school')">School Name</div>
              <div class="thead s-program-name" @click="() => sortApplications('name')">Program Name</div>
              <div class="thead s-intake" @click="() => sortApplications('selected_intake')">Intake</div>
              <div class="thead s-options">Options</div>
              <div class="thead s-actions">Actions</div>
            </div>
            <div class="trow">
              <div class="tdata s-student-id">
                <input type="text" placeholder="Search Student ID" v-model="searchStudentID" @keyup="(ev) => searchApplications('searchStudentID', ev.target.value)" />
              </div>
              <div class="tdata s-app-id">
                <input type="text" placeholder="Search Application ID" v-model="searchID" @keyup="(ev) => searchApplications('searchID', ev.target.value)" />
              </div>
              <div class="tdata s-app-date">
                <input type="text" placeholder="Search Application date" v-model="searchDate" @keyup="(ev) => searchApplications('searchDate', ev.target.value)" />
              </div>
              <div class="tdata s-employee-name">
                <input type="text" placeholder="Search Employee" v-model="searchEmployee" @keyup="(ev) => searchApplications('searchEmployee', ev.target.value)" />
              </div>
              <div class="tdata s-school-name">
                <input type="text" placeholder="Search School name" v-model="searchSchool" @keyup="(ev) => searchApplications('searchSchool', ev.target.value)" />
              </div>
              <div class="tdata s-program-name">
                <input type="text" placeholder="Search Program name" v-model="searchProgram" @keyup="(ev) => searchApplications('searchProgram', ev.target.value)" />
              </div>
              <div class="tdata s-intake">
                <input type="text" placeholder="Search Intake" v-model="searchIntake" @keyup="(ev) => searchApplications('searchIntake', ev.target.value)" />
              </div>
              <div class="tdata s-options"></div>
              <div class="tdata s-actions"></div>
            </div>
            <div v-for="application in filteredApplications['Submitted']" :key="application.id">
              <div class="trow">
                <div class="tdata s-student-id">{{application.user_seq}}</div>
                <div class="tdata s-app-id">{{application.seq_id}}</div>
                <div class="tdata s-app-date">{{application.display_date}}</div>
                <div class="tdata s-employee-name">{{application.employee_name}}</div>
                <div class="tdata s-school-name">{{application.display_school}}</div>
                <div class="tdata s-program-name">{{application.name}}</div>
                <div class="tdata s-intake">{{application.selected_intake}}</div>
                <div class="tdata s-options">
                  <v-select placeholder="Admission Status" size="large" v-model="admissionOption[application.id]"
                    :data="[{label: 'Admitted', value: 'Admitted'}, {label: 'Rejected', value: 'Rejected'}]" style="width:100%"></v-select>
                </div>
                <div class="tdata s-actions">
                  <div>
                    <v-button v-if="admissionOption[application.id]" type="primary" size="small" @click="() => applicationSetStatusAppliedRejected(application)">Submit</v-button>
                    <v-button v-if="!admissionOption[application.id]" disabled type="primary" size="small">Submit</v-button>
                  </div>
                  <div>
                    <v-button type="primary" size="small" v-if="!applicationDetails.includes(application.id)" @click="() => showApplicationDetails(application)">Show Details</v-button>
                    <v-button type="primary" size="small" v-if="applicationDetails.includes(application.id)" @click="() => hideApplicationDetails(application)">Hide Details</v-button>
                  </div>
                </div>
              </div>
              <div class="details" v-if="applicationDetails.includes(application.id)">
                <ApplicationDetails :application="application" :fetchedUsers="fetchedUsers" :fetchedUserDetails="fetchedUserDetails" />
              </div>
            </div>
          </div>
        </div>
      </v-tab-pane>

      <v-tab-pane tab-key="Rejected" tab="Rejected" style="width:100%;">
        <div style="overflow:auto;width:100%;">
          <div class="table" v-if="filteredApplications['Rejected']">
            <div class="trow">
              <div class="thead r-student-id" @click="() => sortApplications('user_seq')">Student ID</div>
              <div class="thead r-app-id" @click="() => sortApplications('seq_id')">Application ID</div>
              <div class="thead r-app-date" @click="() => sortApplications('display_date')">Applied Date</div>
              <div class="thead r-employee-name" @click="() => sortApplications('employee_name')">Employee Name</div>
              <div class="thead r-school-name" @click="() => sortApplications('display_school')">School Name</div>
              <div class="thead r-program-name" @click="() => sortApplications('name')">Program Name</div>
              <div class="thead r-intake" @click="() => sortApplications('selected_intake')">Intake</div>
              <div class="thead r-actions">Actions</div>
            </div>
            <div class="trow">
              <div class="tdata r-student-id">
                <input type="text" placeholder="Search Student ID" v-model="searchStudentID" @keyup="(ev) => searchApplications('searchStudentID', ev.target.value)" />
              </div>
              <div class="tdata r-app-id">
                <input type="text" placeholder="Search Application ID" v-model="searchID" @keyup="(ev) => searchApplications('searchID', ev.target.value)" />
              </div>
              <div class="tdata r-app-date">
                <input type="text" placeholder="Search Application date" v-model="searchDate" @keyup="(ev) => searchApplications('searchDate', ev.target.value)" />
              </div>
              <div class="tdata r-employee-name">
                <input type="text" placeholder="Search Employee" v-model="searchEmployee" @keyup="(ev) => searchApplications('searchEmployee', ev.target.value)" />
              </div>
              <div class="tdata r-school-name">
                <input type="text" placeholder="Search School name" v-model="searchSchool" @keyup="(ev) => searchApplications('searchSchool', ev.target.value)" />
              </div>
              <div class="tdata r-program-name">
                <input type="text" placeholder="Search Program name" v-model="searchProgram" @keyup="(ev) => searchApplications('searchProgram', ev.target.value)" />
              </div>
              <div class="tdata r-intake">
                <input type="text" placeholder="Search Intake" v-model="searchIntake" @keyup="(ev) => searchApplications('searchIntake', ev.target.value)" />
              </div>
              <div class="tdata r-actions"></div>
            </div>
            <div v-for="application in filteredApplications['Rejected']" :key="application.id">
              <div class="trow">
                <div class="tdata r-student-id">{{application.user_seq}}</div>
                <div class="tdata r-app-id">{{application.seq_id}}</div>
                <div class="tdata r-app-date">{{application.display_date}}</div>
                <div class="tdata r-employee-name">{{application.employee_name}}</div>
                <div class="tdata r-school-name">{{application.display_school}}</div>
                <div class="tdata r-program-name">{{application.name}}</div>
                <div class="tdata r-intake">{{application.selected_intake}}</div>
                <div class="tdata r-actions">
                  <div>
                    <v-button type="primary" size="small" v-if="!applicationDetails.includes(application.id)" @click="() => showApplicationDetails(application)">Show Details</v-button>
                    <v-button type="primary" size="small" v-if="applicationDetails.includes(application.id)" @click="() => hideApplicationDetails(application)">Hide Details</v-button>
                  </div>
                </div>
              </div>
              <div class="details" v-if="applicationDetails.includes(application.id)">
                <ApplicationDetails :application="application" :fetchedUsers="fetchedUsers" :fetchedUserDetails="fetchedUserDetails" />
              </div>
            </div>
          </div>
        </div>
      </v-tab-pane>

      <v-tab-pane tab-key="Admitted" tab="Admitted" style="width:100%;">
        <div style="overflow:auto;width:100%;">
          <div class="table" v-if="filteredApplications['Admitted']">
            <div class="trow">
              <div class="thead s-student-id" @click="() => sortApplications('user_seq')">Student ID</div>
              <div class="thead s-app-id" @click="() => sortApplications('seq_id')">Application ID</div>
              <div class="thead s-app-date" @click="() => sortApplications('display_date')">Applied Date</div>
              <div class="thead s-employee-name" @click="() => sortApplications('employee_name')">Employee Name</div>
              <div class="thead s-school-name" @click="() => sortApplications('display_school')">School Name</div>
              <div class="thead s-program-name" @click="() => sortApplications('name')">Program Name</div>
              <div class="thead s-intake" @click="() => sortApplications('selected_intake')">Intake</div>
              <div class="thead s-options">Options</div>
              <div class="thead s-actions">Actions</div>
            </div>
            <div class="trow">
              <div class="tdata s-student-id">
                <input type="text" placeholder="Search Student ID" v-model="searchStudentID" @keyup="(ev) => searchApplications('searchStudentID', ev.target.value)" />
              </div>
              <div class="tdata s-app-id">
                <input type="text" placeholder="Search Application ID" v-model="searchID" @keyup="(ev) => searchApplications('searchID', ev.target.value)" />
              </div>
              <div class="tdata s-app-date">
                <input type="text" placeholder="Search Application Date" v-model="searchDate" @keyup="(ev) => searchApplications('searchDate', ev.target.value)" />
              </div>
              <div class="tdata s-employee-name">
                <input type="text" placeholder="Search Employee" v-model="searchEmployee" @keyup="(ev) => searchApplications('searchEmployee', ev.target.value)" />
              </div>
              <div class="tdata s-school-name">
                <input type="text" placeholder="Search School name" v-model="searchSchool" @keyup="(ev) => searchApplications('searchSchool', ev.target.value)" />
              </div>
              <div class="tdata s-program-name">
                <input type="text" placeholder="Search Program name" v-model="searchProgram" @keyup="(ev) => searchApplications('searchProgram', ev.target.value)" />
              </div>
              <div class="tdata s-intake">
                <input type="text" placeholder="Search Intake" v-model="searchIntake" @keyup="(ev) => searchApplications('searchIntake', ev.target.value)" />
              </div>
              <div class="tdata s-options"></div>
              <div class="tdata s-actions"></div>
            </div>
            <div v-for="application in filteredApplications['Admitted']" :key="application.id">
              <div class="trow">
                <div class="tdata s-student-id">{{application.user_seq}}</div>
                <div class="tdata s-app-id">{{application.seq_id}}</div>
                <div class="tdata s-app-date">{{application.display_date}}</div>
                <div class="tdata s-employee-name">{{application.employee_name}}</div>
                <div class="tdata s-school-name">{{application.display_school}}</div>
                <div class="tdata s-program-name">{{application.name}}</div>
                <div class="tdata s-intake">{{application.selected_intake}}</div>
                <div class="tdata s-options">
                  <v-select placeholder="Admission Status" size="large" v-model="postAdmissionOption[application.id]"
                    :data="postAdmissionOptions" style="width:100%"></v-select>
                </div>
                <div class="tdata s-actions">
                  <div>
                      <v-button v-if="postAdmissionOption[application.id]" type="primary" size="small" @click="() => applicationSetStatusPostAdmission(application)">Submit</v-button>
                      <v-button v-if="!postAdmissionOption[application.id]" disabled type="primary" size="small">Submit</v-button>
                  </div>
                  <div>
                    <v-button type="primary" size="small" v-if="!applicationDetails.includes(application.id)" @click="() => showApplicationDetails(application)">Show Details</v-button>
                    <v-button type="primary" size="small" v-if="applicationDetails.includes(application.id)" @click="() => hideApplicationDetails(application)">Hide Details</v-button>
                  </div>
                </div>
              </div>
              <div class="details" v-if="applicationDetails.includes(application.id)">
                <ApplicationDetails :application="application" :fetchedUsers="fetchedUsers" :fetchedUserDetails="fetchedUserDetails" />
              </div>
            </div>
          </div>
        </div>
      </v-tab-pane>

      <v-tab-pane tab-key="Post Admission" tab="Post Admission" style="width:100%;">
        <div style="overflow:auto;width:100%;">
          <div class="table" v-if="filteredApplications['Post Admission']">
            <div class="trow">
              <div class="thead s-student-id" @click="() => sortApplications('user_seq')">Student ID</div>
              <div class="thead s-app-id" @click="() => sortApplications('seq_id')">Application ID</div>
              <div class="thead s-app-date" @click="() => sortApplications('display_date')">Applied Date</div>
              <div class="thead s-employee-name" @click="() => sortApplications('employee_name')">Employee Name</div>
              <div class="thead s-school-name" @click="() => sortApplications('display_school')">School Name</div>
              <div class="thead s-program-name" @click="() => sortApplications('name')">Program Name</div>
              <div class="thead s-intake" @click="() => sortApplications('selected_intake')">Intake</div>
              <div class="thead s-status" @click="() => sortApplications('status')">Status</div>
              <div class="thead s-actions">Actions</div>
            </div>
            <div class="trow">
              <div class="tdata s-student-id">
                <input type="text" placeholder="Search Student ID" v-model="searchStudentID" @keyup="(ev) => searchApplications('searchStudentID', ev.target.value)" />
              </div>
              <div class="tdata s-app-id">
                <input type="text" placeholder="Search Application ID" v-model="searchID" @keyup="(ev) => searchApplications('searchID', ev.target.value)" />
              </div>
              <div class="tdata s-app-date">
                <input type="text" placeholder="Search Application date" v-model="searchDate" @keyup="(ev) => searchApplications('searchDate', ev.target.value)" />
              </div>
              <div class="tdata s-employee-name">
                <input type="text" placeholder="Search Employee" v-model="searchEmployee" @keyup="(ev) => searchApplications('searchEmployee', ev.target.value)" />
              </div>
              <div class="tdata s-school-name">
                <input type="text" placeholder="Search School name" v-model="searchSchool" @keyup="(ev) => searchApplications('searchSchool', ev.target.value)" />
              </div>
              <div class="tdata s-program-name">
                <input type="text" placeholder="Search Program name" v-model="searchProgram" @keyup="(ev) => searchApplications('searchProgram', ev.target.value)" />
              </div>
              <div class="tdata s-intake">
                <input type="text" placeholder="Search Intake" v-model="searchIntake" @keyup="(ev) => searchApplications('searchIntake', ev.target.value)" />
              </div>
              <div class="tdata s-status">
                <input type="text" placeholder="Search Status" v-model="searchStatus" @keyup="(ev) => searchApplications('searchStatus', ev.target.value)" />
              </div>
              <div class="tdata s-actions"></div>
            </div>
            <div v-for="application in filteredApplications['Post Admission']" :key="application.id">
              <div class="trow">
                <div class="tdata s-student-id">{{application.user_seq}}</div>
                <div class="tdata s-app-id">{{application.seq_id}}</div>
                <div class="tdata s-app-date">{{application.display_date}}</div>
                <div class="tdata s-employee-name">{{application.employee_name}}</div>
                <div class="tdata s-school-name">{{application.display_school}}</div>
                <div class="tdata s-program-name">{{application.name}}</div>
                <div class="tdata s-intake">{{application.selected_intake}}</div>
                <div class="tdata s-status">{{application.status}}</div>
                <div class="tdata s-actions">
                  <div>
                    <v-button type="primary" size="small" v-if="!applicationDetails.includes(application.id)" @click="() => showApplicationDetails(application)">Show Details</v-button>
                    <v-button type="primary" size="small" v-if="applicationDetails.includes(application.id)" @click="() => hideApplicationDetails(application)">Hide Details</v-button>
                  </div>
                </div>
              </div>
              <div class="details" v-if="applicationDetails.includes(application.id)">
                <ApplicationDetails :application="application" :fetchedUsers="fetchedUsers" :fetchedUserDetails="fetchedUserDetails" />
              </div>
            </div>
          </div>
        </div>
      </v-tab-pane>

      <v-tab-pane tab-key="All" tab="All" style="width:100%;">
        <div style="overflow:auto;width:100%;">
          <div class="table" v-if="filteredApplications['All']">
            <div class="trow">
              <div class="thead s-student-id" @click="() => sortApplications('user_seq')">Student ID</div>
              <div class="thead s-app-id" @click="() => sortApplications('seq_id')">Application ID</div>
              <div class="thead s-app-date" @click="() => sortApplications('display_date')">Applied Date</div>
              <div class="thead s-employee-name" @click="() => sortApplications('employee_name')">Employee Name</div>
              <div class="thead s-school-name" @click="() => sortApplications('display_school')">School Name</div>
              <div class="thead s-program-name" @click="() => sortApplications('name')">Program Name</div>
              <div class="thead s-intake" @click="() => sortApplications('selected_intake')">Intake</div>
              <div class="thead s-status" @click="() => sortApplications('status')">Status</div>
              <div class="thead s-actions">Actions</div>
            </div>
            <div class="trow">
              <div class="tdata s-student-id">
                <input type="text" placeholder="Search Student ID" v-model="searchStudentID" @keyup="(ev) => searchApplications('searchStudentID', ev.target.value)" />
              </div>
              <div class="tdata s-app-id">
                <input type="text" placeholder="Search Application ID" v-model="searchID" @keyup="(ev) => searchApplications('searchID', ev.target.value)" />
              </div>
              <div class="tdata s-app-date">
                <input type="text" placeholder="Search Application date" v-model="searchDate" @keyup="(ev) => searchApplications('searchDate', ev.target.value)" />
              </div>
              <div class="tdata s-employee-name">
                <input type="text" placeholder="Search Employee" v-model="searchEmployee" @keyup="(ev) => searchApplications('searchEmployee', ev.target.value)" />
              </div>
              <div class="tdata s-school-name">
                <input type="text" placeholder="Search School name" v-model="searchSchool" @keyup="(ev) => searchApplications('searchSchool', ev.target.value)" />
              </div>
              <div class="tdata s-program-name">
                <input type="text" placeholder="Search Program name" v-model="searchProgram" @keyup="(ev) => searchApplications('searchProgram', ev.target.value)" />
              </div>
              <div class="tdata s-intake">
                <input type="text" placeholder="Search Intake" v-model="searchIntake" @keyup="(ev) => searchApplications('searchIntake', ev.target.value)" />
              </div>
              <div class="tdata s-status">
                <input type="text" placeholder="Search Status" v-model="searchStatus" @keyup="(ev) => searchApplications('searchStatus', ev.target.value)" />
              </div>
              <div class="tdata s-actions"></div>
            </div>
            <div v-for="application in filteredApplications['All']" :key="application.id">
              <div class="trow">
                <div class="tdata s-student-id">{{application.user_seq}}</div>
                <div class="tdata s-app-id">{{application.seq_id}}</div>
                <div class="tdata s-app-date">{{application.display_date}}</div>
                <div class="tdata s-employee-name">{{application.employee_name}}</div>
                <div class="tdata s-school-name">{{application.display_school}}</div>
                <div class="tdata s-program-name">{{application.name}}</div>
                <div class="tdata s-intake">{{application.selected_intake}}</div>
                <div class="tdata s-status">{{application.status}}</div>
                <div class="tdata s-actions">
                  <div>
                    <v-button type="primary" size="small" v-if="!applicationDetails.includes(application.id)" @click="() => showApplicationDetails(application)">Show Details</v-button>
                    <v-button type="primary" size="small" v-if="applicationDetails.includes(application.id)" @click="() => hideApplicationDetails(application)">Hide Details</v-button>
                  </div>
                </div>
              </div>
              <div class="details" v-if="applicationDetails.includes(application.id)">
                <ApplicationDetails :application="application" :fetchedUsers="fetchedUsers" :fetchedUserDetails="fetchedUserDetails" />
              </div>
            </div>
          </div>
        </div>
      </v-tab-pane>


    </v-tabs>

  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { downloadCSV } from '@/utils'
import ApplicationDetails from '@/components/ApplicationDetails.vue'

export default {
  name: 'EmployeeApplications',
  data () {
    return {
      activeTab: 'Applied',
      searchStudentID: '',
      searchID: '',
      searchDate: '',
      searchSchool: '',
      searchProgram: '',
      searchVisaStatus: '',
      searchStatus: '',
      searchEmployee: '',
      searchIntake: '',
      applicationDetails: [],
      fetchedUsers: [],
      fetchedUserDetails: {},
      filteredApplications: {
        Applied: [],
        Assigned: [],
        Submitted: [],
        Admitted: [],
        Rejected: [],
        "Post Admission": [],
        All: []
      },
      fetchedApplications: {
        Applied: [],
        Assigned: [],
        Submitted: [],
        Admitted: [],
        Rejected: [],
        "Post Admission": [],
        All: []
      },
      sorted: {},
      admissionOption: {},
      postAdmissionOption: {},
      waitingForRemoval: {},
      postAdmissionOptions: [
        {label: 'Fee Paid', value: 'Fee Paid'},
        {label: 'Visa Filed', value: 'Visa Filed'},
        {label: 'Visa Granted', value: 'Visa Granted'},
        {label: 'Visa Rejected', value: 'Visa Rejected'}],
      postAdmissionStatuses: ['Fee Paid', 'Visa Filed', 'Visa Rejected', 'Visa Granted']
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'allApplications',
      'fetchedUser'
    ])
  },
  watch: {
    user: {
      handler (val) { },
      immediate: true
    },
    allApplications: {
      handler (val) {
        if (!val) {
          this.$store.dispatch('getAllApplications')
        } else if (val && val.length) {
          val.forEach(application => {
            if (application.status == 'Applied') {
              console.log(application)
            }

            application.display_date = `${('0' + (application.created_at.getMonth() + 1)).slice(-2)}-${('0' + (application.created_at.getDate())).slice(-2)}-${application.created_at.getFullYear()}`
            application.display_school = `${application.school_name}, ${application.school.campus}`
            application.student_id = `${application.userRef.id}`
            if (application.assigned_to) {
              application.employee_name = application.assigned_to.full_name
            }
            let intake = []
            if (application.september) {
              intake.push('September')
            } else if (application.january) {
              intake.push('January')
            } else if (application.may) {
              intake.push('May')
            }
            application.intake = intake.join(', ')

            let tabKey = application.status
            if (this.postAdmissionStatuses.includes(application.status)) {
              tabKey = 'Post Admission'
            }
            this.fetchedApplications[tabKey].push(application)
            this.filteredApplications[tabKey] = [...this.fetchedApplications[tabKey]]
            this.fetchedApplications['All'].push(application)
            this.filteredApplications['All'] = [...this.fetchedApplications['All']]
          })
        }
      },
      immediate: true
    },
    fetchedUser: {
      handler (val) {
        if (val) {
          this.fetchedUsers.push(val.uid)
          this.fetchedUserDetails[val.uid] = val
        }
      }
    }
  },
  methods: {
    searchApplications (key, val) {
      this[key] = val

      if (!this.searchID && !this.searchDate && !this.searchSchool && !this.searchProgram && !this.searchStudentID && !this.searchStatus && !this.searchEmployee && !this.searchIntake) {
        this.filteredApplications[this.activeTab] = [...this.fetchedApplications[this.activeTab]]
      } else {
        this.filteredApplications[this.activeTab] = this.fetchedApplications[this.activeTab].filter(x => {
           if (this.searchStudentID && (x.user_seq + '').toLowerCase().indexOf(this.searchStudentID.toLowerCase()) == -1) {
            return false
          }
          if (this.searchID && x.seq_id.toLowerCase().indexOf(this.searchID.toLowerCase()) == -1) {
            return false
          }
          if (this.searchDate && x.display_date.toLowerCase().indexOf(this.searchDate.toLowerCase()) == -1) {
            return false
          }
          if (this.searchSchool && x.display_school.toLowerCase().indexOf(this.searchSchool.toLowerCase()) == -1) {
             return false
          }
          if (this.searchProgram && x.name.toLowerCase().indexOf(this.searchProgram.toLowerCase()) == -1) {
            return false
          }
          if (this.searchStatus && x.status.toLowerCase().indexOf(this.searchStatus.toLowerCase()) == -1) {
            return false
          }
          if (this.searchEmployee && x.employee_name.toLowerCase().indexOf(this.searchEmployee.toLowerCase()) == -1) {
            return false
          }
          if (this.searchIntake && (x.selected_intake || '').toLowerCase().indexOf(this.searchIntake.toLowerCase()) == -1) {
            return false
          }
          return true
        })
      }
    },
    sortApplications (col) {
      let applications = [...this.filteredApplications[this.activeTab]]
      let sortedAscending = [...this.filteredApplications[this.activeTab]]

      sortedAscending.sort((x, y) => (x[col] || '') > (y[col] || '') ? 1 : (y[col] || '') > (x[col] || '') ? -1 : 0)
      if (this.sorted[col] === undefined) {
        this.sorted[col] = !sortedAscending.every((item, index) => item[col] === applications[index][col])
      } else {
        this.sorted[col] = !this.sorted[col]
      }
      
      if (this.sorted[col]) {
        this.filteredApplications[this.activeTab] = applications.sort((x, y) => (x[col] || '') > (y[col] || '') ? 1 : (y[col] || '') > (x[col] || '') ? -1 : 0)
      } else {
        this.filteredApplications[this.activeTab] = applications.sort((x, y) => (x[col] || '') > (y[col] || '') ? -1 : (y[col] || '') > (x[col] || '') ? 1 : 0)
      }
    },
    assignApplication (application) {
      Object.keys(this.fetchedApplications).forEach(x => {
        this.fetchedApplications[x] = []
      })
      Object.keys(this.filteredApplications).forEach(x => {
        this.filteredApplications[x] = []
      })
      this.$store.dispatch('assignApplication',
        {
          id: application.id,
          payload: {
            status: 'Assigned',
            assigned_to: {
              ref: this.user.ref,
              email: this.user.email,
              full_name: this.user.name || (this.user.first_name + ' ' + this.user.last_name)
            }
          }
        })
    },
    submittedApplication (application) {
      Object.keys(this.fetchedApplications).forEach(x => {
        this.fetchedApplications[x] = []
      })
      Object.keys(this.filteredApplications).forEach(x => {
        this.filteredApplications[x] = []
      })
      this.$store.dispatch('submittedApplication',
        {
          id: application.id,
          status: ['Assigned', 'Submitted'],
          payload: {
            status: 'Submitted'
          }
        })
    },
    applicationSetStatusAppliedRejected (application) {
      Object.keys(this.fetchedApplications).forEach(x => {
        this.fetchedApplications[x] = []
      })
      Object.keys(this.filteredApplications).forEach(x => {
        this.filteredApplications[x] = []
      })
      this.$store.dispatch('applicationSetStatus',
        {
          id: application.id,
          status: ['Admitted', 'Rejected', 'Submitted'],
          payload: {
            status: this.admissionOption[application.id]
          }
        })
    },
    applicationSetStatusPostAdmission (application) {
      Object.keys(this.fetchedApplications).forEach(x => {
        this.fetchedApplications[x] = []
      })
      Object.keys(this.filteredApplications).forEach(x => {
        this.filteredApplications[x] = []
      })
      this.$store.dispatch('applicationSetStatus',
        {
          id: application.id,
          status: ['Admitted', this.postAdmissionOption[application.id]],
          payload: {
            status: this.postAdmissionOption[application.id]
          }
        })
    },
    onChange (tabKey) {
      this.activeTab = tabKey
      // if (tabKey === 'Post Admission') {
      //   if (!this.filteredApplications['Post Admission']) {
      //     this.postAdmissionStatuses.forEach(status => this.$store.dispatch('getApplications', status))
      //   }
      // } else {
      //   if (!this.filteredApplications[tabKey]) {
      //     this.$store.dispatch('getApplications', tabKey)
      //   }
      // }
    },
    showApplicationDetails (application) {
      this.applicationDetails.push(application.id)
      if (!this.fetchedUsers.includes(application.userRef.id)) {
        this.$store.dispatch('getUserFetched', application.userRef.id)
      }
    },
    hideApplicationDetails (application) {
      this.applicationDetails.splice(this.applicationDetails.indexOf(application.id), 1)
    },
    downloadData () {
      const jsonData = this.filteredApplications[this.activeTab]

      const downloadData = jsonData.map(x => {
        let pd = x.student_details ? x.student_details.personal_details : null
        let ela = x.student_details ? x.student_details.english_language_ability : null
        return {
          "ApplicationID": x.seq_id,
          "ApplicationFee": x.application_fee,
          "ApplicationStatus": x.status,
          "AssignedTo": x.employee_name,
          "Student e-Mail": pd ? pd.personal_email : '',
          "Student Phone number": pd ? pd.phone_number : '',
          "Address": (pd && pd.street_address) ? `${pd.street_address || ''}, ${pd.city || ''}, ${pd.province || ''}, ${pd.country || ''} - ${pd.zip_code || ''}` : '',
          "Highest Education": x.student_details ? x.student_details.academic_details.highest_education : '',
          "English language test": ela ? ela.test : '',
          "Test score": ela ? `R ${ela.reading_score} | W ${ela.writing_score} | L ${ela.listening_score} | S ${ela.speaking_score} | Overall ${ela.overall_score}` : '',
          "ProgramID": x.prog_id,
          "ProgramName": x.name,
          "AreaofStudy": x.area_of_study,
          "Duration": x.duration,
          "TutionFee": x.tution_fee,
          "ApplicationFee": x.application_fee,
          "TestScore": x.ielts,
          "SeptemberIntake": (x.selected_intake == 'september') ? 'Yes' : 'No',
          "JanuaryIntake": (x.selected_intake == 'january') ? 'Yes' : 'No',
          "MayIntake": (x.selected_intake == 'may') ? 'Yes' : 'No',
          "School/College": `${x.school_name}, ${x.school.province}`,
          "Source": x.source === 'WebApp' ? 'Application' : 'Associate',
          "StartedOn": x.display_date
        }
      })
      downloadCSV({ filename: `applications-data_${+new Date()}.csv`, data: downloadData})
    }
  },
  components: {
    ApplicationDetails
  }
}
</script>

<style scoped>
.breadcrumb {
  padding: 16px 0;
}
.applications-wrap {
  padding: 16px;
}
.table {
  width: 98%;
  margin: auto;
}
.table .trow {
  display: flex;
  flex-direction: row;
}
.table .thead {
  font-size: 13px;
  padding: 7px 6px;
  background-color: #404040;
  color: ivory;
  border: 1px solid rgba(255, 255, 240, .2);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.table .thead:first-child {
  border-top-left-radius: 2px;
}
.table .thead:last-child {
  border-top-right-radius: 2px;
}
.table .tdata {
  font-size: 12px;
  padding: 5px 6px;
  border: 1px solid rgba(131, 127, 127, 0.137);
  display: flex;
  align-items: center;
}
.table .tdata input {
  width: 100%;
  margin: auto;
  padding: 4px 7px;
  height: 28px;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(0,0,0,.65);
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  -webkit-transition: all .3s;
  transition: all .3s;
}
.trow .student-id {
  width: 16%;
}
.trow .app-id {
  width: 10%;
  text-align: center;
}
.trow .app-date {
  width: 8%;
  justify-content: center;
}
.trow .school-name {
  width: 21%;
}
.trow .program-name {
  width: 21%;
}
.trow .intake {
  width: 12%;
}
.trow .actions {
  min-width: 12%;
  width: 12%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.trow .actions div {
  margin-top: 4px;
}

.trow .a-student-id {
  width: 10%;
}
.trow .a-app-id {
  width: 10%;
}
.trow .a-app-date {
  width: 10%;
  justify-content: center;
}
.trow .a-employee-name {
  width: 14%;
}
.trow .a-school-name {
  width: 16%;
}
.trow .a-program-name {
  width: 16%;
}
.trow .a-intake {
  width: 12%;
}
.trow .a-actions {
  min-width: 12%;
  width: 12%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.trow .a-actions div {
  margin-top: 4px;
}
.trow .s-student-id {
  width: 8%;
}
.trow .s-app-id {
  width: 8%;
}
.trow .s-app-date {
  width: 10%;
  justify-content: center;
}
.trow .s-employee-name {
  width: 12%;
}
.trow .s-school-name {
  width: 14%;
}
.trow .s-program-name {
  width: 14%;
}
.trow .s-intake {
  width: 12%;
}
.trow .s-options, .trow .s-status {
  width: 10%;
}
.trow .s-actions {
  min-width: 12%;
  width: 12%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.trow .s-actions div {
  margin-top: 4px;
}
.trow .r-student-id {
  width: 14%;
}
.trow .r-app-id {
  width: 10%;
}
.trow .r-app-date {
  width: 10%;
  justify-content: center;
}
.trow .r-employee-name {
  width: 14%;
}
.trow .r-school-name {
  width: 16%;
}
.trow .r-program-name {
  width: 15%;
}
.trow .r-intake {
  width: 12%;
}
.trow .r-actions {
  width: 9%;
}
.trow .options .ant-select {
  width: 100% !important;
}
.details {
  padding: 4px 16px;
  border: 1px solid rgba(0, 21, 41, .1);
}
.uploaded-documents {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.uploaded-documents div {
  margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/Employee/EmployeeApplications.vue